/* This is generated code, don't alter */
var IfcObjectTypeEnum;
(function (IfcObjectTypeEnum) {
    IfcObjectTypeEnum[IfcObjectTypeEnum["PRODUCT"] = 0] = "PRODUCT";
    IfcObjectTypeEnum[IfcObjectTypeEnum["PROCESS"] = 1] = "PROCESS";
    IfcObjectTypeEnum[IfcObjectTypeEnum["CONTROL"] = 2] = "CONTROL";
    IfcObjectTypeEnum[IfcObjectTypeEnum["RESOURCE"] = 3] = "RESOURCE";
    IfcObjectTypeEnum[IfcObjectTypeEnum["ACTOR"] = 4] = "ACTOR";
    IfcObjectTypeEnum[IfcObjectTypeEnum["GROUP"] = 5] = "GROUP";
    IfcObjectTypeEnum[IfcObjectTypeEnum["PROJECT"] = 6] = "PROJECT";
    IfcObjectTypeEnum[IfcObjectTypeEnum["NOTDEFINED"] = 7] = "NOTDEFINED";
})(IfcObjectTypeEnum || (IfcObjectTypeEnum = {}));
const IfcObjectTypeEnumCount = 8;
export { IfcObjectTypeEnum, IfcObjectTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcObjectTypeEnum = new Int32Array([1, -5, 7]);
let prefixSumAddressIfcObjectTypeEnum = new Uint32Array([0, 10, 19, 26, 35, 47, 56, 63, 72]);
let slotMapIfcObjectTypeEnum = new Int32Array([3, 1, 5, 2, 7, 6, 4, 0]);
let encodedDataIfcObjectTypeEnum = (new TextEncoder()).encode(".RESOURCE..PROCESS..GROUP..CONTROL..NOTDEFINED..PROJECT..ACTOR..PRODUCT.");
let IfcObjectTypeEnumSearch = new MinimalPerfectHash(gMapIfcObjectTypeEnum, prefixSumAddressIfcObjectTypeEnum, slotMapIfcObjectTypeEnum, encodedDataIfcObjectTypeEnum);
export { IfcObjectTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcObjectTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcObjectTypeEnumSearch, input, cursor, endCursor);
}
